var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes()},[_vm._l((_vm.$slots),function(_,slot){return [_c('div',{key:`InViewAnimation-${slot}`,ref:"item",refInFor:true,class:`${_vm.el}__item${_vm.itemClass ? ` ${_vm.itemClass}` : ''}`,style:(`z-index: ${Object.keys(_vm.$slots).length - slot + 1} ; transition-delay: ${
        0.1 * slot + _vm.delay * 0.1
      }s;`)},[_vm._t(slot)],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }